export class FundingSource {
    id = null;
    name = null;
    code = null;
    description = null;
}